import axios from "axios";
import React from "react";
import { useOutletContext } from "react-router-dom";
import toastr from "../../../utils/toast";

function ContactCard({ contact, update, EditContact }) {
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { setGlobalLoading, token } = useOutletContext();

  async function getMobile(candidate_id) {
    try {
      const response = await axios.get(
        `${REACT_APP_API_BASE_URL}/lusha/get_candidate_mobile/${candidate_id}`,
        { headers: { Authorization: `Bearer ${token}` } },
      );

      update(response.data);
    } catch (error) {
      console.log(error);
      //   toastr.error(error.response.data.message);
    }
  }

  return (
    <>
      <div
        className="border border-primary border-1 rounded p-2 mb-2 d-flex justify-content-between"
        style={{ minHeight: "90px", maxHeight: "90px" }}
      >
        <div className="d-flex text-start justify-content-between">
          <div className="d-flex">
            <div>
              <h6 className="fw-medium mb-1">
                {contact?.firstname + " " + contact?.lastname}
              </h6>
              <p className="text-truncate fs-12 mb-0">
                <i className="fa-solid fa-briefcase text-danger text-opacity-50"></i>{" "}
                {contact?.designation}
              </p>
              {contact?.email && (
                <p className="text-muted op-4 fs-10 mb-0">
                  <i className="fa-regular fa-envelope text-danger text-opacity-50"></i>{" "}
                  {contact?.email
                    ?.split(",")
                    .map((email) => email.trim())
                    .join("\n")}
                </p>
              )}
              {(contact?.mobile || contact?.phone) && (
                <p className="text-muted op-4 fs-10 mb-0">
                  <i className="fa-regular fa-phone text-danger text-opacity-50"></i>{" "}
                  {contact.mobile || contact.phone}
                </p>
              )}
            </div>
          </div>
        </div>
        <div>
          {!contact?.mobile && !contact?.phone && (
            <a
              onClick={async () => {
                const candidate_id = contact?.id;
                await getMobile(candidate_id);
              }}
              className="ms-2 text-decoration-none d-inline-flex fs-12 fw-medium text-primary"
            >
              <i
                title="Request Number"
                className="fa-solid fa-address-book text-secondary"
              ></i>
            </a>
          )}
          <a
            onClick={async () => {
              const candidate_id = contact?.id;
              EditContact(candidate_id);
            }}
            className="ms-2 text-decoration-none d-inline-flex fs-12 fw-medium text-primary"
          >
            <i
              title="Edit Contact"
              className="fa-solid fa-pen text-secondary"
            ></i>
          </a>
        </div>
      </div>
    </>
  );
}

export default ContactCard;
